// components
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import LinkButton from '@/components/Button/LinkButton';
import PassportTransferFAQ from '@/components/passport/PassportTransferFAQ/PassportTransferFAQ';

// constants
import { ORIGIN_STRING } from "@/lib/constants";
import { PASSPORT_TRANSFER_SIGNED_IN_WITHOUT_PASSPORT_FAQ_BANK } from '@/components/passport/PassportTransferFAQ/PassportTransferFAQContent';

// styles
import styles from './PassportTransferNoMemberships.module.scss';
import { clearLocalProfile } from '@/lib/helpers/handle-sign-out';
import { ssoLogoutLink } from '@/lib/helpers/sso-links';
import { isEmpty } from '@/lib/helpers/empty';
import { useHasMounted } from '@/lib/hooks';

interface PassportTransferNoMembershipsProps {
  email: string;
}

export default function PassportTransferNoMemberships(props: PassportTransferNoMembershipsProps) {
  const hasMounted = useHasMounted()
  let useADifferentEmailRedirectURL = '/passport/transfer/';

  if(hasMounted) {
    const hostname = isEmpty(ORIGIN_STRING) ? `https://${window.location.host}` : ORIGIN_STRING
    useADifferentEmailRedirectURL = `${hostname}${useADifferentEmailRedirectURL}`
  }

  const { email } = props;

  return (
    <div className={styles.passport_transfer_no_memberships} data-sentry-component="PassportTransferNoMemberships" data-sentry-source-file="PassportTransferNoMemberships.tsx">
      <h1>You’re Signed In With an Email That Doesn’t Have Access to Passport</h1>
      <p className={styles.passport_transfer_no_memberships__description}>
        {`The email you’re signed in with, `}
        <span>{email}</span>
        {`, does not have an active Passport benefit. To transfer your Passport access to a different email, you’ll need to sign in with the email you currently use to access Passport.`} 
      </p>
      <LinkButton
        href={`${ssoLogoutLink}?redirect=${useADifferentEmailRedirectURL}`}
        style='white'
        wrapperComponent='a'
        onClick={clearLocalProfile}
      data-sentry-element="LinkButton" data-sentry-source-file="PassportTransferNoMemberships.tsx">
        Sign Out & Start Over
      </LinkButton>
      <PassportTransferFAQ faqBank={PASSPORT_TRANSFER_SIGNED_IN_WITHOUT_PASSPORT_FAQ_BANK} data-sentry-element="PassportTransferFAQ" data-sentry-source-file="PassportTransferNoMemberships.tsx" />
    </div>
  )
}
